const features = {
    WRITE_HEADLINES_USING_AI: 3,
    GENERATE_CREATIVE: 4,
    VALIDATE_CREATIVE: 5,
    AUTOFIX_CREATIVE: 6,
    AI_SHADOWS: 14,
    GENERATE_EFFECT: 16
}
export default features